import { ExportButton } from "app/components/ExportButton";
import {
  List,
  Datagrid,
  TextField,
  Create,
  SimpleForm,
  required,
  Edit,
  TopToolbar,
  SaveButton,
  DeleteButton,
  ReferenceInput,
  SelectInput,
  DateField,
  SimpleShowLayout,
  FileField,
  FileInput,
  FormTab,
  TabbedForm,
  useNotify,
  FilterButton,
  CreateButton,
} from "react-admin";

export class OperatorUpdateCommand {
  private permission: string;

  constructor(data: any) {
    this.permission = data.permission ?? "";
  }

  static fromJson(data: any) {
    return new OperatorUpdateCommand(data);
  }
}

const OperatorPermission = [
  { id: "Read", name: "Read" },
  { id: "ReadWrite1", name: "ReadWrite1" },
  { id: "ReadWrite2", name: "ReadWrite2" }
];

const ListFilters = [
  <ReferenceInput source="userId" reference="users" perPage={100} label="User">
    <SelectInput optionText="name" optionValue="id" />
  </ReferenceInput>,
  <ReferenceInput source="clientId" reference="clients" perPage={100} label="Client">
    <SelectInput optionText="name" optionValue="id" />
  </ReferenceInput>
];

export const OperatorList = () => (
  <List
    filters={ListFilters}
    actions={
      <TopToolbar>
        <FilterButton />
        <CreateButton />
        <ExportButton resource="operators" />
      </TopToolbar>
    }>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <DateField source="createdAt" showTime />
      <TextField source="user.name" label="User" sortBy="userId" />
      <TextField source="client.name" label="Client" sortBy="clientId" />
      <TextField source="permission" />
    </Datagrid>
  </List>
);

const validateCreation = (values: any) => {
  const errors: any = {};

  if (values.file) {
    return errors;
  }
  if (!values.userId) {
    errors.email = "Required";
  }  
  if (!values.clientId) {
    errors.role = "Required";
  }  
  if (!values.permission) {
    errors.name = "Required";
  }  

  return errors;
};

export const OperatorCreate = () => {
  const notify = useNotify();
  const onError = (error?: any) => {
    notify(`Could not create client: ${error?.response?.data?.title ?? error?.message}`, { type: "error" });
  };

  return (
    <Create mutationOptions={{ onError }} redirect="list">
      <TabbedForm validate={validateCreation}>
        <FormTab label="single">
          <ReferenceInput source="userId" reference="users" perPage={100} label="User" validate={required()}>
            <SelectInput optionText="name" optionValue="id" />
          </ReferenceInput>
          <ReferenceInput source="clientId" reference="clients" perPage={100} label="Client" validate={required()}>
            <SelectInput optionText="name" optionValue="id" />
          </ReferenceInput>
          <SelectInput source="permission" options={{ label: "Permission" }} choices={OperatorPermission} validate={required()} />
        </FormTab>
  
        <FormTab label="file">
          <FileInput source="file" label="CSV (email*,clientId*,permission*)" accept="text/csv" multiple={false}>
            <FileField source="src" title="title" />
          </FileInput>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};

const EditActions = () => (
  <TopToolbar>
    <SaveButton />
    <DeleteButton />
  </TopToolbar>
);

export const OperatorEdit = () => (
  <Edit>
    <SimpleForm toolbar={<EditActions />}>
      <SimpleShowLayout>
        <TextField source="id" />
        <DateField source="createdAt" showTime />
        <TextField source="user.name" label="User" />
        <TextField source="client.name" label="Client" />
      </SimpleShowLayout>
      <SelectInput source="permission" options={{ label: "Permission" }} choices={OperatorPermission} validate={required()} />
    </SimpleForm>
  </Edit>
);
